import emoji from "react-easy-emoji";

import googlelogo from "./assets/img/icons/common/google.svg";
import github from "./assets/img/icons/common/github.svg";
import airbnb from "./assets/img/icons/common/airbnbLogo.png";

export const greetings = {
	name: "Megalith Solutions",
	title: "We're Megalith Solutions",
	description:
		"A passionate team of solutions engineers . Our mission is to enable people and businesses throughout the world to realize their full potential.",
	resumeLink: "",
};

export const openSource = {
	githubUserName: "",
};

export const contact = {};

export const socialLinks = {
};

export const skillsSection = {
	title: "What We Do",
	subTitle:
		"FULL STACK DEVELOPERS WHO WANT TO EXPLORE EVERY TECH STACK",
	skills: [
		emoji(
			"⚡ Develop highly interactive Front end / User Interfaces for your web applications"
		),
		emoji(
			"⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"
		),
		emoji(
			"⚡ Integration of third party services such as Firebase / Auth0 / Paypal / Adyen ..."
		),
		emoji(
			"⚡ Deployment with cloud services as Google Cloud / AWS"
		),
	],

	softwareSkills: [
		{
			skillName: "html-5",
			fontAwesomeClassname: "vscode-icons:file-type-html",
		},
		{
			skillName: "css3",
			fontAwesomeClassname: "vscode-icons:file-type-css",
		},
		{
			skillName: "sass",
			fontAwesomeClassname: "logos:sass",
		},
		{
			skillName: "JavaScript",
			fontAwesomeClassname: "logos:javascript",
		},
		{
			skillName: "TypeScript",
			fontAwesomeClassname: "logos:typescript-icon",
		},
		{
			skillName: "reactjs",
			fontAwesomeClassname: "vscode-icons:file-type-reactjs",
		},
		{
			skillName: "angular",
			fontAwesomeClassname: "logos:angular-icon",
		},
		{
			skillName: "swift",
			fontAwesomeClassname: "logos:swift",
		},
		{
			skillName: "flutter",
			fontAwesomeClassname: "logos:flutter",
		},
		{
			skillName: "nodejs",
			fontAwesomeClassname: "logos:nodejs-icon",
		},
		{
			skillName: "dot-net",
			fontAwesomeClassname: "cib:dot-net",
		},
		{
			skillName: "php",
			fontAwesomeClassname: "vscode-icons:file-type-php3",
		},
		{
			skillName: "python",
			fontAwesomeClassname: "vscode-icons:file-type-python",
		},
		{
			skillName: "django",
			fontAwesomeClassname: "logos:django",
		},
		{
			skillName: "npm",
			fontAwesomeClassname: "vscode-icons:file-type-npm",
		},
		{
			skillName: "sql-database",
			fontAwesomeClassname: "vscode-icons:file-type-sql",
		},
		{
			skillName: "kafka",
			fontAwesomeClassname: "logos:kafka",
		},
		{
			skillName: "apache-spark",
			fontAwesomeClassname: "cib:apache-spark",
		},
		{
			skillName: "hadoop",
			fontAwesomeClassname: "logos:hadoop",
		},
		{
			skillName: "mongoDB",
			fontAwesomeClassname: "vscode-icons:file-type-mongo",
		},
		{
			skillName: "google-cloud",
			fontAwesomeClassname: "logos:google-cloud",
		},
		{
			skillName: "aws",
			fontAwesomeClassname: "logos:aws",
		},
		{
			skillName: "firebase",
			fontAwesomeClassname: "logos:firebase",
		},
		{
			skillName: "python",
			fontAwesomeClassname: "logos:python",
		},
		{
			skillName: "git",
			fontAwesomeClassname: "logos:git-icon",
		},
		{
			skillName: "jenkins",
			fontAwesomeClassname: "logos:jenkins",
		},
		{
			skillName: "docker",
			fontAwesomeClassname: "logos:docker-icon",
		},
	],
};

export const SkillBars = [
	{
		Stack: "Frontend/Design", 
		progressPercentage: "90", 
	},
	{
		Stack: "Backend",
		progressPercentage: "90",
	},
	{
		Stack: "Mobile App",
		progressPercentage: "90",
	},
	{
		Stack: "Automation",
		progressPercentage: "90",
	},
	{
		Stack: "Devops",
		progressPercentage: "85",
	}
];

export const educationInfo = [
	{
		schoolName: "Custom Software Development",
		subHeader: "",
		duration: "CSD",
		desc: "Custom software development allows for specialized solutions. Megalith professional software engineers formulate seamless user experiences to deliver unique and secure technology.",
		descBullets: [
			"Custom Software: Custom software is the future of your business and businesses everywhere. If you can easily integrate generic software that already exists for the masses, it may be an indicator that your services lack the diversity necessary to compete against your competitors. Megalith  Custom Software and Apps can help distinguish your business from the competition. We center your vision and needs when crafting your custom software, app, and mobile development.",
			"ERP Solutions"
		],
	},
	{
		schoolName: "Web Design and Development",
		subHeader: "",
		duration: "WDD",
		desc: "Whether it be a complex customer portal, a web app or a custom ecommerce website Megalith will deliver a fully UI/UX and search engine optimized online experience accessible from any device, anywhere.",
		descBullets: [
			"Web Development: A custom website is the most adaptable option, allowing designers and developers complete control to ensure your site is catered to your business. With a custom website comes guaranteed search engine optimization, performance, analytics, and insurance that your website's core web vitals are optimized. Our web developers are equipped with years of experience optimizing websites for search engines like Google and Bing search engines, as well as page load speed, and user experience.",
			"UI/UX Design",
			"Search Engine Optimization"
		],
	},
	{
		schoolName: "Turnkey Solutions",
		subHeader: "",
		duration: "TS",
		desc: "In a hurry to get your website or online store live? We will create a ready-to-launch website with the look and feel of a custom web experience for your business. Take ownership of your business and facilitate ecommerce, marketing, or content creation.",
		descBullets: [
			"Shopify Development",
			"WordPress Development",
		],
	},
	{
		schoolName: "Automation",
		subHeader: "",
		duration: "AT",
		desc: "",
		descBullets: [
			"RPA: Increase productivity, efficiency and compliance so employees can focus on higher-value work by automating routine, repetitive tasks. Part of the industry-leading RPA technologies makes end-to-end automation happen.",
			"Enable the innovator and the enterprise: Empower citizen developers, administrators and professional developers with a low-code experience to solve business problems and scale innovation across the organization.",
			"Accelerate work and drive productivity: Improve employee productivity, reduce errors and improve process adherence across your business operations.",
			"Automate today, scale tomorrow: Leverage agility, on-demand capacity, governance capabilities and security to quickly solve today's problems and still grow and scale to meet tomorrow's needs."
		],
	}
];

export const experience = [
	{
		role: "Software Engineer",
		company: "Google",
		companylogo: googlelogo,
		date: "June 2018 – Present",
		desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		descBullets: [
			"Lorem ipsum dolor sit amet, consdfgectetur adipiscing elit",
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		],
	},
	{
		role: "Front-End Developer",
		company: "Github",
		companylogo: github,
		date: "May 2017 – May 2018",
		desc: "Lorem ipsum dolor sit amet, consefdctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
	},
	{
		role: "Software Engineer Intern",
		company: "Airbnb",
		companylogo: airbnb,
		date: "Jan 2015 – Sep 2015",
		desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
	},
];

export const projects = [
	{
		name: "VNAmazing",
		desc: "It is an ecommerce platform for booking tours and pay via top payment gateways as Napas, Adyen. It’s a cooperation project with Vietnam Airlines. Customers can buy combo tours and airline tickets with attractive prices.",
		descList: [],
		softwareSkills: [
			{
				skillName: "html-5",
				fontAwesomeClassname: "vscode-icons:file-type-html",
			},
			{
				skillName: "css3",
				fontAwesomeClassname: "vscode-icons:file-type-css",
			},
			{
				skillName: "sass",
				fontAwesomeClassname: "logos:sass",
			},
			{
				skillName: "reactjs",
				fontAwesomeClassname: "vscode-icons:file-type-reactjs",
			},
			{
				skillName: "nodejs",
				fontAwesomeClassname: "logos:nodejs-icon",
			},
			{
				skillName: "php",
				fontAwesomeClassname: "vscode-icons:file-type-php3",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "jenkins",
				fontAwesomeClassname: "logos:jenkins",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			},
			{
				skillName: "google-cloud",
				fontAwesomeClassname: "logos:google-cloud",
			}
		],
		link: "https://vnamazing.vietnamairlines.com/",
	},
	{
		name: "Vinpearl Booking",
		desc: "It is an ecommerce platform for booking hotels, tours, airline tickets and pay via top payment gateways as Smartlink,. It’s a cooperation project with Vinpearl. Customers can buy combo hotels, tours and airline tickets with attractive prices.",
		descList: [],
		softwareSkills: [
			{
				skillName: "html-5",
				fontAwesomeClassname: "vscode-icons:file-type-html",
			},
			{
				skillName: "css3",
				fontAwesomeClassname: "vscode-icons:file-type-css",
			},
			{
				skillName: "sass",
				fontAwesomeClassname: "logos:sass",
			},
			{
				skillName: "reactjs",
				fontAwesomeClassname: "vscode-icons:file-type-reactjs",
			},
			{
				skillName: "dot-net",
				fontAwesomeClassname: "cib:dot-net",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "jenkins",
				fontAwesomeClassname: "logos:jenkins",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			},
			{
				skillName: "aws",
				fontAwesomeClassname: "logos:aws",
			},
		],
		link: "https://booking.vinpearl.com/",
	},
	{
		name: "Galaxy Play",
		desc: "It is a subscription-based streaming service offering online streaming from a library of films and television series as Netflix. Users can use website, applications from the App/Google store/Samsung TV.",
		descList: [],
		softwareSkills: [
			{
				skillName: "html-5",
				fontAwesomeClassname: "vscode-icons:file-type-html",
			},
			{
				skillName: "css3",
				fontAwesomeClassname: "vscode-icons:file-type-css",
			},
			{
				skillName: "sass",
				fontAwesomeClassname: "logos:sass",
			},
			{
				skillName: "angular",
				fontAwesomeClassname: "logos:angular-icon",
			},
			{
				skillName: "nodejs",
				fontAwesomeClassname: "logos:nodejs-icon",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "jenkins",
				fontAwesomeClassname: "logos:jenkins",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			},
			{
				skillName: "aws",
				fontAwesomeClassname: "logos:aws",
			},
		],
		link: "https://galaxyplay.vn/browse",
	},
	{
		name: "Binh Phuoc Provincial Public News",
		desc: "It is a website to publish the government’s news, policies, TV shows of Binh Phuoc province.",
		descList: [],
		softwareSkills: [
			{
				skillName: "html-5",
				fontAwesomeClassname: "vscode-icons:file-type-html",
			},
			{
				skillName: "css3",
				fontAwesomeClassname: "vscode-icons:file-type-css",
			},
			{
				skillName: "dot-net",
				fontAwesomeClassname: "cib:dot-net",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			}
		],
		link: "https://congan.binhphuoc.gov.vn/",
	},
	{
		name: "GoFast News",
		desc: "It is a website for ShopeeFood drivers to get the news, policies, drivers care packages, recruitment... It also has an Admin portal to configure the content in the website.",
		descList: [],
		softwareSkills: [
			{
				skillName: "html-5",
				fontAwesomeClassname: "vscode-icons:file-type-html",
			},
			{
				skillName: "css3",
				fontAwesomeClassname: "vscode-icons:file-type-css",
			},
			{
				skillName: "python",
				fontAwesomeClassname: "vscode-icons:file-type-python",
			},
			{
				skillName: "django",
				fontAwesomeClassname: "logos:django",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "jenkins",
				fontAwesomeClassname: "logos:jenkins",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			}
		],
		link: "https://gofast.vn/tin-tuc/",
	},
	{
		name: "ShopeeFood Driver Application",
		desc: "It is an application for Drivers to get/receive orders, topup/withdraw money, check income…. In the Backend side, it has algorithms to assign orders to best match drivers, optimize route by routing engine, stacking/grouping orders….",
		descList: [],
		softwareSkills: [
			{
				skillName: "swift",
				fontAwesomeClassname: "logos:swift",
			},
			{
				skillName: "flutter",
				fontAwesomeClassname: "logos:flutter",
			},
			{
				skillName: "python",
				fontAwesomeClassname: "vscode-icons:file-type-python",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "jenkins",
				fontAwesomeClassname: "logos:jenkins",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			}
		],
		link: "https://play.google.com/store/apps/details?id=vn.foody.delivery&hl=vi&gl=US",
	},
	{
		name: "Shopee Express Instant Service",
		desc: "It is a sub service in this app, it offers a service for users to ship parcels instantly. It integrates with payment gateways in VN as: ShopeePay, VNPay, Cybersource",
		descList: [],
		softwareSkills: [
			{
				skillName: "reactjs",
				fontAwesomeClassname: "vscode-icons:file-type-reactjs",
			},
			{
				skillName: "django",
				fontAwesomeClassname: "logos:django",
			},
			{
				skillName: "python",
				fontAwesomeClassname: "vscode-icons:file-type-python",
			},
			{
				skillName: "mysql",
				fontAwesomeClassname: "cib:mysql",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "jenkins",
				fontAwesomeClassname: "logos:jenkins",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			}
		],
		link: "https://play.google.com/store/apps/details?id=com.deliverynow&hl=vi&gl=US",
	},
	{
		name: "ShopeeFood Fraud Detection",
		desc: "It is a platform for detecting fraud cases from buyers, drivers, merchants when running food delivery services. It has 4 main components: fraud detector, fraud cases management, trace & follow, reports",
		descList: [],
		softwareSkills: [
			{
				skillName: "kafka",
				fontAwesomeClassname: "logos:kafka",
			},
			{
				skillName: "python",
				fontAwesomeClassname: "vscode-icons:file-type-python",
			},
			{
				skillName: "git",
				fontAwesomeClassname: "logos:git-icon",
			},
			{
				skillName: "docker",
				fontAwesomeClassname: "logos:docker-icon",
			}
		],
		link: "https://admin.shopeefood.vn/fraud/management/case",
	},
	{
		name: "BigData & Machine Learning",
		desc:"",
		descList: [
			"ETA prediction: system estimates time arrival of 1 order by using orders historical data by machine learningItem-based recommendation for League of Legends game when LOL runs big campaigns or promotions. System suggest best items to gamers using user’s historical data",
			"Item-based recommendation for League of Legends game when LOL runs big campaigns or promotions. System suggest best items to gamers using user’s historical data",
			"Reporting for GNT games: collect huge data from tracking in the games (https://www.gnt.com.vn/vi/products) and generate to reports "
		],
		softwareSkills: [
			{
				skillName: "kafka",
				fontAwesomeClassname: "logos:kafka",
			},
			{
				skillName: "apache-spark",
				fontAwesomeClassname: "cib:apache-spark",
			},
			{
				skillName: "hadoop",
				fontAwesomeClassname: "logos:hadoop",
			}
		]
	},
	{
		name: "Testing Service",
		desc:"We also offer testing service, some projects have been tested by us:",
		descList: [
			"+ ShopeePay application",
			"+ Customer service management for LOL game in VN",
			"+ Sales tracking for Gcafe Plus (software for management at game center)",
			"+ VNPay ecommerce (VNPay Shop)",
			"+ Accesstrade (affiliate platform for marketing in Asia)",
			"+ X-ray devices for Hitachi in hospital",
			"+ New model for Sharp devices"
		],
		softwareSkills: []
	}
];

export const feedbacks = [
	{
		name: "Real Estate IQ",
		feedback: "",
		src: "https://therealestateiq.com/layout/logo-login.svg",
		href: "https://realestateiq.co/"
	},
	{
		name: "Hyphen Solutions",
		feedback: "",
		src: "https://www.hyphensolutions.com/info/images/website_logo.svg",
		href: "https://www.hyphensolutions.com/info/"
	},
	{
		name: "Newline Interactive",
		feedback: "",
		src: "data:image/png;base64,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",
		href: "https://newline-interactive.com/usa/"
	},
	{
		name: "RiShine Groups",
		feedback: "",
		src: "https://media-exp1.licdn.com/dms/image/C510BAQHT_fo4kTbvpA/company-logo_200_200/0/1554303150382?e=2147483647&v=beta&t=H7ADrzT870k3O1Bh91pSepcUuqMq8oNzD6TfQ1dL3Uk",
		href: "https://www.linkedin.com/company/rslcc/"
	},
	{
		name: "Venture",
		feedback: "",
		src: "https://media-exp1.licdn.com/dms/image/C4D0BAQH2goYHkcQZUA/company-logo_200_200/0/1590158082414?e=2147483647&v=beta&t=EQRPFK1S3y2Kex0EAgzKCnDaPVeJP1xrBpB9LLSWDwo",
		href: "https://www.venturelogistics.com/"
	},
	{
		name: "MWLogistics",
		feedback: "",
		src: "data:image/jpeg;base64,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",
		href: "https://mwlogistics.com/"
	},
	{
		name: "Kofax",
		feedback: "",
		src: "https://www.kofax.com/-/media/images/global/logos/logo-blue.svg",
		href: "https://www.kofax.com/"
	},
	{
		name: "Google Cloud",
		feedback: "",
		src: "https://www.gstatic.com/devrel-devsite/prod/v1346a1a19ce7aae82d055a3118aedfea60b43eff91360935b38d0524ec70ff05/cloud/images/cloud-logo.svg",
		href: "https://cloud.google.com/"
	},
	{
		name: "Microsoft Power Automate",
		feedback: "",
		src: "data:image/jpeg;base64,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",
		href: "https://powerautomate.microsoft.com/en-us/"
	},
];

export const profile = {
	avatar_url: "https://storage.googleapis.com/media-realestateiq/realestateiq/uploads/1668250958147-megalith_log.png",
	contact_name: "An",
	contact_email: "an@megalithinc.com",
	contact_phone: "+4695148664"
}
